import { Reveal, SectionHeader } from "./Reveal";
import { MagnusCrest } from "./Logo";

export default function About() {
    return (
        <section id="sobre" className="bg-white py-20 sm:py-28 lg:py-32">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14">
                <div className="lg:col-span-4">
                    <SectionHeader
                        eyebrow="Sobre nós"
                        title={
                            <>
                                Sobre
                                <br />
                                <span className="italic text-gold-deep">a Magnus</span>
                            </>
                        }
                    />
                    <Reveal delay={0.2}>
                        <MagnusCrest className="w-28 mt-10 hidden lg:block" />
                    </Reveal>
                </div>

                <div className="lg:col-span-8 space-y-8">
                    <Reveal delay={0.1}>
                        <p className="font-display text-2xl sm:text-3xl font-medium text-ink leading-snug">
                            A Magnus Personalizados nasceu com o propósito de
                            transformar ideias em produtos que carregam
                            significado.
                        </p>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <p className="font-body text-base sm:text-lg text-inksoft leading-relaxed">
                            Trabalhamos com personalizados para presentes,
                            eventos, empresas e momentos especiais, sempre
                            buscando unir qualidade, criatividade e cuidado em
                            cada detalhe.
                        </p>
                    </Reveal>
                    <Reveal delay={0.26}>
                        <p className="font-body text-base sm:text-lg text-inksoft leading-relaxed">
                            Para nós, cada pedido tem uma história por trás.
                            Por isso, cada produto é produzido pensando na
                            pessoa que irá receber e no momento que ele
                            representa.
                        </p>
                    </Reveal>
                    <Reveal delay={0.32}>
                        <div className="hairline-gold max-w-sm" />
                        <p className="font-display italic text-xl text-gold-deep mt-6">
                            Feito especialmente para cada cliente.
                        </p>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
